// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
// @flow

import ChannelTypes from './channels';
import ErrorTypes from './errors';
import GeneralTypes from './general';
import UserTypes from './users';
import TeamTypes from './teams';
import PostTypes from './posts';
import FileTypes from './files';
import PreferenceTypes from './preferences';
import IntegrationTypes from './integrations';
import EmojiTypes from './emojis';
import AdminTypes from './admin';
import AlertTypes from './alerts';
import JobTypes from './jobs';
import SearchTypes from './search';
import RoleTypes from './roles';
import SchemeTypes from './schemes';

// 添加自定义的action type
import CustomizeTypes from './customsize';

export {
    ErrorTypes,
    GeneralTypes,
    UserTypes,
    TeamTypes,
    ChannelTypes,
    PostTypes,
    FileTypes,
    PreferenceTypes,
    IntegrationTypes,
    EmojiTypes,
    AdminTypes,
    AlertTypes,
    JobTypes,
    SearchTypes,
    RoleTypes,
    SchemeTypes,

    // 添加自定义的action type
    CustomizeTypes,
};
